module.exports = __webpack_public_path__ + "img/w-soc-media.4949cff1.svg";